import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ErrorBoundary from '../../../error/ErrorBoundary/ErrorBoundary';

const InvoiceCreatorV2Component = lazy(() => import('../components'));
const ReceiptBuilder = lazy(() => import('../components/ReceiptBuilder'));
const ReceiptRendererPage = lazy(() => import('../components/renderer/ReceiptRendererPage'));

const InvoiceCreatorV2Route: RouteObject = {
  path: 'invoice-creator-v2',
  children: [
    { index: true, element: <InvoiceCreatorV2Component /> },
    { path: 'new', element: <ReceiptBuilder /> },
    { path: 'edit', element: <ReceiptBuilder mode="edit" /> },
  ],
};

// Customer-facing digital receipt (v2): /invoiceV2?billToken=… — mirrors v1's
// /invoice route and, like it, sits outside the dashboard shell. Auth is the
// bill token (see services/auth.ts), not a Keycloak session.
export const InvoiceV2Route: RouteObject = {
  path: '/invoiceV2',
  element: <ReceiptRendererPage />,
  errorElement: <ErrorBoundary />,
};

export default InvoiceCreatorV2Route;
